import type { ModuleTagEntry } from './index';

/** VOI LUT module tags. */
export const tags: ModuleTagEntry[] = [
  'WindowCenter',
  'WindowWidth',
  'VOILUTFunction',
  'WindowCenterWidthExplanation',
];
